export const leaveApplicationFields = [
  {
    name: "startDate",
    label: "Start Date",
    type: "date",
    required: true,
    gridColumn: "span 2",
    onChange: (value, values, setFieldValue) => {
      if (value) {
        const start = new Date(value);
        // only compute end date when the user has supplied a days count
        if (values.numberOfDays) {
          const end = new Date(start);
          end.setDate(end.getDate() + parseInt(values.numberOfDays, 10));
          setFieldValue("endDate", end.toISOString().split("T")[0]);
        }

        // if an end date already existed and no days value, leave it alone
        // (we no longer auto‑fill anything)
      }
    },
  },
  {
    name: "numberOfDays",
    label: "Number of Leave Days",
    type: "number",
    required: false,
    gridColumn: "span 2",
    onChange: (value, values, setFieldValue) => {
      if (value && values.startDate) {
        const start = new Date(values.startDate);
        const end = new Date(start);
        end.setDate(end.getDate() + parseInt(value, 10));
        setFieldValue("endDate", end.toISOString().split("T")[0]);
      } else if (!value) {
        // Clear endDate when numberOfDays is emptied
        setFieldValue("endDate", "");
      }
    },
  },
  {
    name: "endDate",
    label: "End Date",
    type: "date",
    required: true,
    gridColumn: "span 2",
    onChange: (value, values, setFieldValue) => {
      // recalc days when the end date changes
      if (value && values.startDate) {
        const diff =
          (new Date(value) - new Date(values.startDate)) /
          (1000 * 60 * 60 * 24);
        setFieldValue("numberOfDays", diff >= 0 ? diff : "");
      }
    },
  },
  {
    name: "autoAccessDocuments",
    label: "Access Documents?",
    type: "checkbox",
    gridColumn: "span 2",
  },
  {
    name: "autoAccessCase",
    label: "Access Case?",
    type: "checkbox",
    gridColumn: "span 2",
  },
];
export const adjustLeaveBalanceFields = [
  {
    name: "balance",
    label: "Leave Balance (Days)",
    type: "number",
    required: true,
    gridColumn: "span 2",
  },
];
// Employee Form Fields Configuration
export const employeeFormFields = [
  // Personal Information Section
  {
    name: "firstName",
    label: "First Name",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },

  // Compensation Section
  {
    name: "basicSalary",
    label: "Basic Salary (KES)",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "partnersDrawing",
    label: "Partners Drawing (KES)",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "leaveDaysPerYear",
    label: "Leave Days Per Year",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "isActive",
    label: "Active Employee",
    type: "checkbox",
    gridColumn: "span 2",
    required: false,
  },

  // Statutory Information Section
  {
    name: "krapinNumber",
    label: "KRA PIN Number",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "nssfNumber",
    label: "NSSF Number",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "nhifNumber",
    label: "NHIF Number",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "taxStatus",
    label: "Tax Status",
    type: "select",
    options: [
      { value: "RESIDENT", label: "Resident" },
      { value: "NON_RESIDENT", label: "Non-Resident" },
      { value: "EXEMPT", label: "Exempt" },
    ],
    gridColumn: "span 2",
    required: true,
  },

  // Payroll Deduction Settings
  {
    name: "payrollDeductionMethod",
    label: "Payroll Deduction Method",
    type: "select",
    options: [
      { value: "STANDARD", label: "Standard Deduction" },
      { value: "PERCENTAGE", label: "Percentage Based" },
      { value: "FIXED", label: "Fixed Amount" },
    ],
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "nssfContributionMethod",
    label: "NSSF Contribution Method",
    type: "select",
    options: [
      { value: "TIER_1", label: "Tier 1" },
      { value: "TIER_2", label: "Tier 2" },
      { value: "BOTH", label: "Both Tiers" },
    ],
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "pensionRate",
    label: "Pension Rate (%)",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },

  // Bank Details Section
  {
    name: "hasBankDetails",
    label: "Add Bank Details",
    type: "checkbox",
    gridColumn: "span 4",
    required: false,
    onChange: (value, values, setFieldValue) => {
      if (!value) {
        // Clear bank fields when unchecked
        setFieldValue("bankName", "");
        setFieldValue("branchName", "");
        setFieldValue("branchCode", "");
        setFieldValue("accountNumber", "");
      }
    },
  },
  {
    name: "bankName",
    label: "Bank Name",
    type: "text",
    gridColumn: "span 2",
    required: false,
    disableCondition: {
      fieldName: "hasBankDetails",
      value: false,
    },
  },
  {
    name: "branchName",
    label: "Branch Name",
    type: "text",
    gridColumn: "span 2",
    required: false,
    disableCondition: {
      fieldName: "hasBankDetails",
      value: false,
    },
  },
  {
    name: "branchCode",
    label: "Branch Code",
    type: "text",
    gridColumn: "span 2",
    required: false,
    disableCondition: {
      fieldName: "hasBankDetails",
      value: false,
    },
  },
  {
    name: "accountNumber",
    label: "Account Number",
    type: "text",
    gridColumn: "span 2",
    required: false,
    disableCondition: {
      fieldName: "hasBankDetails",
      value: false,
    },
  },
];
export const leavePolicyFields = [
  {
    name: "gender",
    label: "Gender",
    type: "select",
    options: [
      { label: "Male", value: 1 },
      { label: "Female", value: 2 },
      { label: "Other", value: 3 },
    ],
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "acrues",
    label: "Acrues",
    type: "checkbox",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "accrualRate",
    label: "Accrual Rate",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "accrualDate",
    label: "Accrual Date",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "canCarryForward",
    label: "Can Carry Forward",
    type: "checkbox",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "maxDaysCarryForward",
    label: "Max Days Carry Forward",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "maxOpenApplications",
    label: "Max Open Applications",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "maxDays",
    label: "Max Days",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
];
export const CompanyCalendarSetupsFormFields = [
  { name: "holiday", label: "Holiday", type: "text", required: true },

  {
    name: "holidayDate",
    label: "Holiday Date",
    type: "date",
    gridColumn: "span 2",
    required: true,
  },
];

export const imprestApplicationsForms = [

  // {
  //   name: "title",
  //   label: "Title",
  //   type: "text",
  //   required: true,
  //   gridColumn: "span 2",
  // },

  {
    name: "description",
    label: "Description",
    type: "text",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "isPettyCash",
    label: "Is this a Petty Cash?",
    type: "checkbox",
    required: false,
    gridColumn: "span 1",
  },
  {
    name: "caseRelated",
    label: "Case Related?",
    type: "checkbox",
    required: false,
    gridColumn: "span 1",
    parent: "main",
  },
];

export const claimApplicationsForm = [

  // {
  //   name: "title",
  //   label: "Title",
  //   type: "text",
  //   required: true,
  //   gridColumn: "span 2",
  // },

  {
    name: "description",
    label: "Description",
    type: "text",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "isPettyCash",
    label: "Is this a Petty Cash?",
    type: "checkbox",
    required: false,
    gridColumn: "span 1",
  },
  {
    name: "caseRelated",
    label: "Case Related?",
    type: "checkbox",
    required: false,
    gridColumn: "span 1",
    parent: "main",
  },
];

export const staffClaimsFields = [
  {
    name: "title",
    label: "Title",
    type: "text",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    required: true,
    gridColumn: "span 2",
  },
];
export const feeNoteFormFields = [
  {
    name: "documentType",
    label: "Document Type",
    type: "select",
    required: true,
    gridColumn: "span 2",
    options: [
      { label: "Proforma Fee Note", value: "proforma" },
      { label: "Final Fee Note", value: "final" },
    ],
  },
  {
    name: "documentNumber",
    label: "Document Number",
    type: "number",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "issueDate",
    label: "Issue Date",
    type: "date",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "branch",
    label: "Branch",
    type: "select",
    required: true,
    gridColumn: "span 2",
    options: [
      { label: "Nairobi", value: "nairobi" },
      { label: "Mombasa", value: "mombasa" },
      { label: "Kisumu", value: "kisumu" },
    ],
  },
  {
    name: "client",
    label: "Client",
    type: "select",
    required: true,
    gridColumn: "span 2",
    options: [
      { label: "SILAS GITARI - SG-Gen", value: "silas_gitari" },
      // You can populate dynamically from API later
    ],
  },
  {
    name: "file",
    label: "File",
    type: "select",
    required: true,
    gridColumn: "span 2",
    options: [
      { label: "(O) G/SG-GEN/002/0/17 ==> General File", value: "general_file" },
    ],
  },
  {
    name: "sendDocumentTo",
    label: "Send Document To",
    type: "text",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "billingInformation",
    label: "Billing Information",
    type: "textarea",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "dateDue",
    label: "Date Due",
    type: "date",
    required: false,
    gridColumn: "span 1",
  },
  {
    name: "currency",
    label: "Currency",
    type: "select",
    required: true,
    gridColumn: "span 1",
    options: [
      { label: "KES", value: "KES" },
      { label: "USD", value: "USD" },
    ],
  },
  {
    name: "exchangeRate",
    label: "Exchange Rate",
    type: "number",
    required: true,
    gridColumn: "span 1",
  },
  {
    name: "userAssigned",
    label: "User Assigned",
    type: "select",
    required: true,
    gridColumn: "span 2",
    options: [
      { label: "Jamila Hassan", value: "jamila_hassan" },
      { label: "John Doe", value: "john_doe" },
    ],
  },
  {
    name: "approver",
    label: "Approver",
    type: "select",
    required: true,
    gridColumn: "span 2",
    options: [
      { label: "Silas Gitari", value: "silas_gitari" },
    ],
  },
  {
    name: "bankAccount",
    label: "Bank Account",
    type: "select",
    required: true,
    gridColumn: "span 2",
    options: [
      { label: "CLIENT ACCOUNT - DIB Bank (KSHS)", value: "dib_kshs" },
      { label: "CLIENT ACCOUNT - Equity Bank (USD)", value: "equity_usd" },
    ],
  },
  {
    name: "attentionTo",
    label: "To the Attention Of",
    type: "text",
    required: false,
    gridColumn: "span 2",
  },
];
